// extracted by mini-css-extract-plugin
export default {"wrap":"_cf3ff079","iconWrap":"_b41a2192","icon":"_c6afc4e6","heartButton":"_1858011"};